"use strict";
//Class generated from template src/main/resources/template/javascript/ClientTemplate.vm
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GaiaClient = void 0;
var VariableRegistry_1 = __importDefault(require("../api/VariableRegistry"));
var GaiaClient = /** @class */ (function () {
    function GaiaClient(options, transporter) {
        this.options = options;
        this.transporter = transporter;
    }
    GaiaClient.prototype.queryNative = function (statement, variables) {
        if (variables === void 0) { variables = {}; }
        var body = { statement: statement, variables: variables };
        return this.transporter.transport(this.options, body);
    };
    GaiaClient.prototype.query = function (request) {
        var _a = this.getStatement("query", request), statement = _a[0], variables = _a[1];
        return this.queryNative(statement, variables);
    };
    GaiaClient.prototype.mutationNative = function (statement, variables) {
        if (variables === void 0) { variables = {}; }
        var body = { statement: statement, variables: variables };
        return this.transporter.transport(this.options, body);
    };
    GaiaClient.prototype.mutation = function (request) {
        var _a = this.getStatement("mutation", request), statement = _a[0], variables = _a[1];
        return this.mutationNative(statement, variables);
    };
    GaiaClient.prototype.subscriptionNative = function (statement, variables) {
        if (variables === void 0) { variables = {}; }
        var body = { statement: statement, variables: variables };
        return this.transporter.transport(this.options, body);
    };
    GaiaClient.prototype.subscription = function (request) {
        var _a = this.getStatement("subscription", request), statement = _a[0], variables = _a[1];
        return this.subscriptionNative(statement, variables);
    };
    GaiaClient.prototype.getStatement = function (name, type) {
        var registry = new VariableRegistry_1.default();
        var fields = type.map(function (e) { return e(registry); }).join(" ");
        if (registry.getDatatypes().length == 0) {
            var statement_1 = name + " gaia { " + fields + " }";
            return [statement_1, registry.getVariables()];
        }
        var statement = name + " gaia(" + registry.getDatatypes().join(", ") + ") { " + fields + " }";
        return [statement, registry.getVariables()];
    };
    return GaiaClient;
}());
exports.GaiaClient = GaiaClient;
//# sourceMappingURL=GaiaClient.js.map